"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINALS_END_POSITION = exports.SEMI_FINALS_END_POSITION = exports.QUARTER_FINALS_END_POSITION = void 0;
exports.QUARTER_FINALS_END_POSITION = 3;
exports.SEMI_FINALS_END_POSITION = 2;
exports.FINALS_END_POSITION = 1;
//# sourceMappingURL=finals-end-positions.js.map